@if (selectedAttachments.length > 0) {
    <div class="attachment-selections-bar">
        @for (attachment of selectedAttachments; track attachment.attachmentId) {
            <div class="attachment-pill">
                <div class="pill-info">
                    <span
                        class="pill-filename"
                        helpTooltip
                        [tooltipText]="attachment.attachmentName + '.' + attachment.fileExtension"
                    >
                        {{ attachment.attachmentName }}.{{ attachment.fileExtension }}
                    </span>
                    <span class="pill-filesize">({{ formatFileSize(attachment.fileSize) }})</span>
                </div>
                @if (editMode()) {
                    <button
                        class="ace-btn btn-sm has-icon btn-secondary m-0"
                        type="button"
                        title="Remove attachment"
                        (click)="removeAttachment(attachment)"
                    >
                        <i class="fa fa-trash"></i>
                    </button>
                }
            </div>
        }
    </div>
}
